import { defineComponent } from 'vue'

import VButton from '@/components/common/button/VButton'
import VIcon from '@/components/common/VIcon'
import useAuth from '@/composables/auth/useAuth'
import useLocalization from '@/composables/localization/useLocalization'

export default defineComponent(() => {
  const { localeTexts, translationWithFragmentKeys } = useLocalization()
  const auth = useAuth()
  return () => (
    <div
      t-data='empty-booking-list-page'
      class='flex w-full flex-col items-center justify-center px-4 pt-22 tablet:px-0 tablet:pt-32'
    >
      <div class='relative rounded-full border border-dashed border-primary-300 bg-primary-50 p-8'>
        <VIcon
          class='text-[64px] text-primary-400'
          icon='material-symbols:calendar-month-outline'
        />
        <div class='absolute right-0 -translate-y-1 rounded-full bg-warning-400 p-1.5'>
          <VIcon
            class='text-[20px] text-white'
            icon='material-symbols:star'
          />
        </div>
      </div>
      <h1 class='mt-8 text-center text-heading-4 break-word'>
        {translationWithFragmentKeys(
          'agent-firsttime-heading',
          [{ fragment_key: 'agent-firstname', value: auth.userProfile?.first_name_en }]
        )}
      </h1>
      <div class='mt-5 w-[264px] text-center text-heading-5 text-neutral-800'>
        {localeTexts.value['agent-firsttime-paragraph']}
      </div>
      <div class='mt-5'>
        <VButton
          to='/booking'
        >
          {localeTexts.value['agent-firsttime-booking-btn']}
        </VButton>
      </div>
    </div>
  )
}, {
  name: 'EmptyBookingList'
})
